import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateRangeAvailableUpdateSoComponent } from './date-range-available-update-so.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MyDateRangePickerModule } from 'mydaterangepicker';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MyDateRangePickerModule
  ],
  declarations: [DateRangeAvailableUpdateSoComponent],
  exports: [DateRangeAvailableUpdateSoComponent]
})
export class DateRangeAvailableUpdateSoModule { }



// WEBPACK FOOTER //
// ./src/app/utils/date-range-available-update-so/date-range-available-update-so.module.ts